export default __webpack_public_path__ + "static/salesReps-8159d5c990db6d39e5b1968a021e7c72.png";